import { render, staticRenderFns } from "./CardItemScaffold.vue?vue&type=template&id=b4cdeae0"
import script from "./CardItemScaffold.vue?vue&type=script&lang=ts"
export * from "./CardItemScaffold.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4cdeae0')) {
      api.createRecord('b4cdeae0', component.options)
    } else {
      api.reload('b4cdeae0', component.options)
    }
    module.hot.accept("./CardItemScaffold.vue?vue&type=template&id=b4cdeae0", function () {
      api.rerender('b4cdeae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/CardItemScaffold.vue"
export default component.exports